/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Winterinocccoolingtemperaturesetpoint4Inputs */



/**
* | output |
* | --- |
* | "Winter unoccupied cooling setpoint" |
*
* @param {Ahu_History_Key_Winterinocccoolingtemperaturesetpoint4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_winterinocccoolingtemperaturesetpoint4 = /** @type {((inputs?: Ahu_History_Key_Winterinocccoolingtemperaturesetpoint4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Winterinocccoolingtemperaturesetpoint4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Winter unoccupied cooling setpoint")
	return /** @type {LocalizedString} */ ("Consigne froid inoccupation hiver")
});
export { ahu_history_key_winterinocccoolingtemperaturesetpoint4 as "ahu_history_key_winterInoccCoolingTemperatureSetpoint" }